/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { ISzfCarouselContainerData } from './szf-carousel-container.data';
import { ISzfCarouselContainerProps } from './szf-carousel-container.props.autogenerated';

export interface ISzfCarouselContainerViewProps extends ISzfCarouselContainerProps<ISzfCarouselContainerData> {}

/**
 *
 * SzfCarouselContainer component
 * @extends {React.PureComponent<ISzfCarouselContainerProps<ISzfCarouselContainerData>>}
 */
class SzfCarouselContainer extends React.PureComponent<ISzfCarouselContainerProps<ISzfCarouselContainerData>> {
    public render(): JSX.Element | null {
        return this.props.renderView(this.props);
    }
}

export default SzfCarouselContainer;
